import type { ApiServiceReqRes } from '@meego-setting/idl-api/apiMap'

export { RPC, type ApiServiceReqRes } from '@meego-setting/idl-api/apiMap'

export const ISettingApiService = Symbol('ISettingApiService')

export interface ISettingApiService {
  request<RPC extends keyof ApiServiceReqRes>(apiName: RPC, data: ApiServiceReqRes[RPC]['req']): ApiServiceReqRes[RPC]['res'];
}

